import { useWebStreamWs } from '@/ws/web-stream.ws'

export const useWebSocket = () => {
  const webStreamWs = useWebStreamWs()

  const createSocket = (streamName) => {
    let subscription = null

    return {
      subscribe: async(onMessage, onSubscribe) => {
        if (!subscription) {
          subscription = await webStreamWs.subscribeAsync(
            [streamName],
            onMessage,
            onSubscribe
          )
        }
      },
      unsubscribe: () => {
        if (subscription) {
          webStreamWs.unsubscribe(subscription)
          subscription = null
        }
      }
    }
  }

  return { createSocket }
}
